import { Box } from "@logora/parliament.ui.box";
import { Label } from "@logora/parliament.ui.label";
import { OpenInNew } from "@mui/icons-material";
import { Link, Stack } from "@mui/material";
import React from "react";
import styles from "./ConseilConstitutionnel.module.scss";

export const ConseilConstitutionnel = ({ acteLegislatif }) => {
	const date = new Date(acteLegislatif.dateActe).toLocaleDateString("fr-FR", {
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	const displayConclusion = () => {
		const libelleStatutConclusion = acteLegislatif.libelleStatutConclusion;
		const colorMapping = {
			success: "Conforme",
			info: "Partiellement conforme",
		};

		if (libelleStatutConclusion === null) {
			return "Contrôle du Conseil constitutionnel en cours";
		}

		return (
			<Label
				variantsObject={colorMapping}
				colorType={libelleStatutConclusion}
				text={libelleStatutConclusion}
			/>
		);
	};

	return (
		<>
			{acteLegislatif.codeActe === "CC-SAISIE-AN" && (
				<Label
					colorType={"neutral"}
					variantsObject={{
						info: "neutral",
					}}
					className={styles.label}
					text={`Le Conseil constitutionnel a été saisi par 60 députés minimum, le ${date}`}
				/>
			)}
			{acteLegislatif.codeActe === "CC-SAISIE-DROIT" && (
				<Label
					colorType={"neutral"}
					variantsObject={{
						info: "neutral",
					}}
					className={styles.label}
					text={`Le Conseil constitutionnel a été saisi de droit, le ${date}`}
				/>
			)}

			<Box title={"Conclusion"}>
				<Stack gap={1}>
					{displayConclusion()}

					{acteLegislatif.urlConclusionConseilConstitutionnel && (
						<Link
							href={acteLegislatif.urlConclusionConseilConstitutionnel}
							target="_blank"
							rel="noreferrer"
							sx={{
								textDecoration: "none",
								color: "inherit",
								fontWeight: "bold",
							}}
						>
							<Stack direction="row" gap="5px" alignItems="center">
								Voir les détails de la conclusion
								<OpenInNew fontSize="small" />
							</Stack>
						</Link>
					)}
				</Stack>
			</Box>
		</>
	);
};
